import {
    Box,
    Typography,
    RadioGroup,
    FormControlLabel,
    Radio,
    Tabs,
    Tab,   
} from "@mui/material";
import { FormatListBulleted, ViewStream, FormatListNumbered} from "@mui/icons-material";
import { ConcatenatedPreview } from "./ConcatenatedPreview";

export const LayoutSelector = ({
  layout,
  listType,
  onLayoutChange,
  onListTypeChange,
  wrapperStart,
  wrapperEnd,
  separator,
}) => {
  const tabIndex = layout === "LIST" ? 0 : 1;

  const handleTab = (_, newIndex) => {
    onLayoutChange(newIndex === 0 ? "LIST" : "CONCATENATED");
  };

  return (
    <Box>

      <Tabs
        value={tabIndex}
        onChange={handleTab}
        textColor="primary"
        indicatorColor="primary"
        sx={{
          mb: 1.5,
          "& .MuiTab-root": {
            fontWeight: 700,
            fontSize: "0.8rem",
            minHeight: 36,
          },
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Tab
          id="layout-tab-list"
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              <FormatListBulleted fontSize="small" />
              Lista
            </Box>
          }
        />
        <Tab
          id="layout-tab-concatenated"
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              <ViewStream fontSize="small" />
              Concatenado (Vista previa)
            </Box>
          }
        />
      </Tabs>

      {tabIndex === 0 && (
        <Box>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ mb: 1, display: "block" }}
          >
            Los testigos se mostrarán en una lista. Elige el tipo:
          </Typography>
          <RadioGroup
            row
            value={listType}
            onChange={(e) => onListTypeChange(e.target.value)}
          >
            <FormControlLabel
              value="BULLET"
              control={<Radio size="small" sx={{ color: "#1976d2" }} />}
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <FormatListBulleted fontSize="small" />
                  <Typography variant="body2">Viñeta</Typography>
                </Box>
              }
            />
            <FormControlLabel
              value="NUMBER"
              control={<Radio size="small" sx={{ color: "#1976d2" }} />}
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <FormatListNumbered fontSize="small" />
                  <Typography variant="body2">Enumerado</Typography>
                </Box>
              }
            />
          </RadioGroup>
        </Box>
      )}

      {tabIndex === 1 && (
        <ConcatenatedPreview
          wrapperStart={wrapperStart}
          wrapperEnd={wrapperEnd}
          separator={separator}
        />
      )}
    </Box>
  );
};